// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { UptimeRepoService } from '@client/app/services/api/uptime-repo/uptime-repo.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'incident-list',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header [header]="'All incident checkpoints in the selected time span' | translate"></page-header>
        </div>
        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                    <table-container
                        [collection]="downtimes"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="progress"
                        noResultMessage="{{ 'Good job! No incidents was registered' | translate }}"
                    >
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="col-sm-12 col-md-12 text-left" translate>Outages start</th>
                                    <th class="col-sm-12 col-md-12" translate>Outages end</th>
                                    <th class="col-sm-4 col-md-4 text-right" translate>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let downtime of downtimes">
                                    <td class="text-left text-v-middle">{{ downtime.start_at | monSetMyTimezone | uptimeIncidientTime }}</td>
                                    <td class="text-left text-v-middle">
                                        <span *ngIf="downtime.end_at">
                                            {{ downtime.end_at | monSetMyTimezone | uptimeIncidientTime }}
                                        </span>
                                        <span *ngIf="!downtime.end_at" translate>
                                            Undetermined
                                        </span>
                                    </td>
                                    <td class="text-right text-v-middle">{{ duration(downtime.start_at, downtime.end_at) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class IncidentListComponent extends BaseContainerComponentController implements OnInit {
    @Input() uptime: any;
    @Input() startDate: any;
    @Input() endDate: any;

    downtimes: any[] = [];
    progress: any = null;

    override getPage = () => {
        const params = {
            start_date: this.startDate,
            end_date: this.endDate,
            page_size: this.pageSize,
            page: this.page,
        };

        this.progress = this.uptimeRepoService.getDowntimes(this.uptime.id, params).then((downTimesData: any) => {
            this.downtimes = downTimesData;
        }, () => {});
        return this.progress;
    };

    constructor (
        private uptimeRepoService: UptimeRepoService,
        private dateTimeService: DateTimeService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.downtimes = [];
        this.progress = null;
        this.getPage();
    }

    duration (start: any, end: any): string {
        if (!end) {
            return this.dateTimeService.durationHumanized(undefined, start);
        }
        return this.dateTimeService.durationHumanized(start, end);
    }
}
